import { GOAL_TYPE_CONFIG } from '../config/goalTypeConfig';
import { GOAL_CATEGORY } from '../constants/goals';
export const getIsMarketingGoal = goalType => {
  const goalTypeConfig = GOAL_TYPE_CONFIG[goalType];
  const goalCategory = goalTypeConfig && goalTypeConfig.category;
  return goalCategory === GOAL_CATEGORY.MARKETING;
};